export default "__VITE_ASSET__22Pj6S8U__"